import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/data';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function SonbookRelation() {
  const section = useScrollReveal();

  return (
    <section className="w-full min-h-[85svh] flex items-center px-6 md:px-10 py-20 md:py-28 bg-gradient-to-b from-primary-50/70 via-background-50 to-background-50" ref={section.ref}>
      <div className={`w-full max-w-5xl mx-auto transition-all duration-700 ease-out ${section.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        <div className="flex items-center justify-center gap-2.5 mb-6">
          <span className="block w-5 h-px bg-primary-400/50"></span>
          <span className="text-[13px] font-medium text-primary-600 tracking-[0.15em] uppercase whitespace-nowrap">品牌合作</span>
          <span className="block w-5 h-px bg-primary-400/50"></span>
        </div>

        <div className="text-center">
          <h2 className="font-heading text-[2.25rem] md:text-[2.75rem] font-semibold text-foreground-950 leading-[1.15] tracking-tight mb-8">
            品牌經銷與合作洽詢
          </h2>
          <div className="max-w-2xl mx-auto space-y-5">
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed font-medium">
              如有樂律文化品牌經銷、通路合作、內容合作、媒體或其他相關合作需求，請透過官方聯絡方式提出詢問。
            </p>
            <p className="text-base md:text-lg text-foreground-500 leading-relaxed">
              品牌經銷與合作方案詳情請直接聯繫洽詢。
            </p>
          </div>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href={siteConfig.sonbookUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="whitespace-nowrap inline-flex items-center gap-2.5 px-6 py-3 rounded-full text-[15px] font-medium bg-primary-500 text-white hover:bg-primary-600 transition-colors cursor-pointer tracking-wide"
            >
              前往崧博出版
              <i className="ri-external-link-line text-[13px]"></i>
            </a>
            <a
              href={siteConfig.catalogUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="whitespace-nowrap inline-flex items-center gap-2.5 px-6 py-3 rounded-full text-[15px] font-medium bg-gradient-to-r from-accent-500 to-primary-500 text-white hover:from-accent-600 hover:to-primary-600 transition-all cursor-pointer tracking-wide"
            >
              前往書籍資料庫
              <i className="ri-external-link-line text-[13px]"></i>
            </a>
            <Link
              to="/faq"
              className="whitespace-nowrap inline-flex items-center gap-2.5 px-6 py-3 rounded-full text-[15px] font-medium border border-secondary-300 text-secondary-700 hover:border-secondary-400 hover:bg-secondary-50 transition-all cursor-pointer"
            >
              常見問題
              <i className="ri-arrow-right-line text-[13px]"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}